import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { branding, contactLine, loadBranding, onBranding } from '../utils/branding';

/* Shown only when a screen is printed with the browser (Print buttons that print the page itself). */
const PrintHeader = () => {
  const [b, setB] = useState(branding());
  useEffect(() => {
    loadBranding().then(setB);
    return onBranding(setB);
  }, []);
  if (!b) return null;
  return (
    <div className="print-only print-head">
      {b.logo && <img src={b.logo} alt="" />}
      <div>
        <div className="org">{b.org_name}</div>
        <div className="contact">{contactLine(b)}</div>
      </div>
      <div className="when">Printed {dayjs().format('DD/MM/YYYY HH:mm')}</div>
      <style>{`
        .print-only { display: none; }
        @media print {
          .print-only { display: flex !important; }
          .print-head { align-items: center; gap: 14px; border-bottom: 2px solid #333; padding-bottom: 8px; margin-bottom: 12px; }
          .print-head img { max-height: 64px; max-width: 160px; object-fit: contain; }
          .print-head .org { font-size: 17px; font-weight: bold; }
          .print-head .contact { font-size: 10px; color: #555; }
          .print-head .when { margin-left: auto; font-size: 10px; color: #555; }
          .ant-layout-sider, .ant-layout-header, .view-as-banner { display: none !important; }
          .ant-layout-content { margin: 0 !important; padding: 0 !important; }
        }
      `}</style>
    </div>
  );
};

export default PrintHeader;
